// extracted by mini-css-extract-plugin
export default {"text":"email_link_text__GQ-hH"};